import { snack } from "components/Snack/Snack";
import AppForm from "components/AppForm/AppForm";
import CrudPage from "components/CrudPage/CrudPage";
import withRouter from "hoc/withRouter";
import { withRemoteDataAndSpinner } from "hoc/withRemoteDataAndSpinner";
import { useLoadAll } from "hooks/useLoadAll";
import inputTypeEnum from "enums/inputTypes";
import ZikrsSAService from "services/superadmin/zikrsSAService";
import { languages } from "globals-variables";

const ZikrForm = ({
  router: {
    navigate,
    params: { id, language },
  },
  data: { zikr },
}) => {

  const fieldsWithData = [
    {
      key: "name",
      label: "Название",
      required: true,
      inputType: inputTypeEnum.text,
    },
    {
      key: "description",
      label: "Описание",
      inputType: inputTypeEnum.richText,
    },
    {
      key: "arabicText",
      label: "Арабский текст",
      required: true,
      inputType: inputTypeEnum.text,
    },
    {
      key: "transcription",
      label: "Транскрипция",
      required: true,
      inputType: inputTypeEnum.text,
    },
    {
      key: "translation",
      label: "Перевод",
      required: true,
      inputType: inputTypeEnum.richText,
    },
    {
      key: "count",
      label: "Количество",
      inputType: inputTypeEnum.number,
    },
    {
      key: "language",
      label: "Язык",
      inputType: inputTypeEnum.select,
      required: true,
      options: languages.map(l => ({
        id: l.key,
        name: l.label
      }))
    }
  ]

  const onSubmit = async (formValues) => {
    try {
      if (zikr) {
        await ZikrsSAService.put(id, formValues)
        snack("Данное обновлен успешно!");
      } else {
        await ZikrsSAService.post(formValues)
        snack("Данное успешно создан!");
      }

      setTimeout(() => {
        navigate(-1);
      }, 500);
    } catch (ex) {
      console.error(ex)
    }
  };

  return (
    <CrudPage title={zikr ? 'Редактирование зикра' : 'Создание зикра'}>
      <AppForm onSubmit={onSubmit} data={zikr} fields={fieldsWithData}></AppForm>
    </CrudPage>
  );
};

export default withRouter(
  withRemoteDataAndSpinner(ZikrForm, (router) => {
    let requests = {}
    const language = router.params.language || 'ru'
    if (router.params.id) {
      requests['zikr'] = () => ZikrsSAService.get(router.params.id, { language })
    }
    return useLoadAll(requests);
  })
);
